/* eslint-disable react/no-this-in-sfc */
import React, { useContext, useState } from 'react'
import useQuery from 'hooks/useQuery'
import AutoScroll from 'components/common/Enhancers/AutoScroll'
import RolesForm from 'components/Forms/Role/RolesForm'
import PasswordPrompt from 'components/Prompts/PasswordPrompt'
import { AdminDataContext } from 'context/AdminDataContext'
import { Roles } from 'utils/enums'

export function UpdateFormContainer({
  initialValues,
  roleObject,
  setSelectedUser,
  referenceFields,
  inputsWithOptions,
}) {
  const {
    specialities,
    fetchSpecialities,
    fetchMediators,
    fetchAccounts,
    fetchClients,
    fetchTranslators,
  } = useContext(AdminDataContext)
  const { makeRequest } = useQuery({
    defaultMethod: 'put',
    isControlled: true,
    toastOptions: {
      showFeedbackMessage: true,
      resultMessageError: { 401: 'Contraseña incorrecta' },
    },
    disableAutoLogoutOn401: true,
  })

  const [updatePrompt, setUpdatePrompt] = useState(null)
  const [errorStatus, setErrorStatus] = useState(null)
  const [errorMessage, setErrorMessage] = useState(null)

  const onSubmitForm = async ({ values, setSubmitting, role: roleObject }) => {
    const sendData = async (authPassword) => {
      setSubmitting(true)
      const registerResponse = await makeRequest({
        endpoint: `/admins/${roleObject.mainPath}`,
        body: { ...initialValues, ...values, authPassword },
      })
      setSubmitting(false)
      if (registerResponse.error) {
        setErrorStatus(registerResponse.status)
        setErrorMessage(registerResponse.message)
        return
      }
      if (roleObject.role === Roles.Client.role) {
        if (!specialities.some((s) => s.name === values.speciality)) {
          await fetchSpecialities()
        }
        await fetchClients()
      } else if (roleObject.role === Roles.Mediator.role) {
        await fetchMediators()
      } else if (roleObject.role === Roles.Translator.role) {
        await fetchTranslators()
      } else if (roleObject.role === Roles.Account.role) {
        await fetchAccounts()
      }
      setSelectedUser(null)
      setUpdatePrompt(null)
      return registerResponse.error
    }
    setSubmitting(false)
    setUpdatePrompt({ title: 'Ingrese su contraseña', onOk: sendData })
  }

  return (
    <>
      <AutoScroll dependencies={initialValues}>
        <RolesForm
          title='Modificar Usuario'
          initialValues={initialValues}
          onSubmitForm={onSubmitForm}
          error={errorStatus}
          errorMessage={errorMessage}
          rolesToShow={[roleObject]}
          referenceFields={referenceFields}
          inputsWithOptions={inputsWithOptions}
          updating
        />
      </AutoScroll>
      {updatePrompt && (
        <PasswordPrompt prompt={updatePrompt} setShowPrompt={setUpdatePrompt} />
      )}
    </>
  )
}

export default UpdateFormContainer
